module.exports = __webpack_public_path__ + "img/cardiff-rugby-logo-icon.980f2c5c.png";